import { FloorBack, FloorFront, FloorShade, FloorSheen } from './floor.art';
import { floorRegions } from './floor.geometry';
import type { SceneDefinition } from './types';

/** Floor: one long polished floor receding to the back wall, with seams as an option. */
export const floorScene: SceneDefinition = {
  id: 'floor',
  surface: 'floor',
  regions: floorRegions,
  Back: FloorBack,
  Shade: FloorShade,
  Sheen: FloorSheen,
  Front: FloorFront,
  seams: true,
  photo: null,
};
